
import { defineComponent } from "vue";
import router from "@/router";

import PiarBasicDataTab from "./PiarBasicDataTab.vue";
import PiarAdjustmentsTab from "./PiarAdjustmentsTab.vue";

import { IPiarModel } from "@/interfaces/modules";
import PiarService from "@/api/Piar/PiarService";

export default defineComponent({
    name: "PiarDetailView",
    components: {
        PiarBasicDataTab,
        PiarAdjustmentsTab,
    },
    data() {
        return {
            activeTab: 0,
            piarId: 0,
            piar: {} as IPiarModel,
            loading: false,
            loaded: false,
        };
    },
    computed: {
        isNew(): boolean {
            return this.piarId <= 0;
        },
    },
    async mounted() {
        const idParam = this.$route.params.Id as string | undefined;
        const id = idParam ? parseInt(idParam, 10) : 0;

        this.piarId = isNaN(id) ? 0 : id;

        if (!this.isNew) {
            await this.loadPiar();
        }

        this.loaded = true;
    },
    methods: {
        setTab(index: number) {
            this.activeTab = index;
        },
        async loadPiar() {
            this.loading = true;
            try {
                const result = await PiarService.GetById(this.piarId);

                this.piar = result;
                this.loaded = true;
            } finally {
                this.loading = false;
            }
        },
        goBack() {
            router.back();
        }
    },
});
